/**
 * Props every hub page receives from EventShell. Declared once so the pages stay
 * about their own content rather than repeating the same six prop definitions.
 */
export default {
  props: {
    event: { type: Object, required: true },
    eventId: { type: String, required: true },
    dashboard: { type: Object, default: () => ({}) },
    media: { type: Object, default: () => ({}) },
    recordings: { type: Array, default: () => [] },
    hubProvenance: { type: Object, default: null },
  },
};
